import { Star } from "lucide-react";
import { useWebsiteContent } from "@/hooks/useWebsiteContent";

const Testimonials = () => {
  const { content } = useWebsiteContent();

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-background">
      <div className="max-w-[980px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-[680px] mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-foreground tracking-[-0.03em] leading-tight mb-4">
            {content.testimonials_title}
          </h2>
          <p className="text-xl text-muted-foreground font-normal">
            {content.testimonials_subtitle}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-5">
          {content.testimonials.map((testimonial, index) => (
            <article
              key={index}
              className="bg-card rounded-2xl p-8 transition-all duration-300 hover:shadow-md h-full flex flex-col"
            >
              {/* Rating */}
              <div className="flex gap-0.5 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-foreground text-foreground" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-foreground/70 leading-relaxed mb-6 text-[15px] flex-1">
                "{testimonial.quote}"
              </blockquote>

              {/* Transformation */}
              <div className="mb-6">
                <span className="text-xs font-medium text-primary bg-primary/[0.06] rounded-full px-3 py-1">
                  {testimonial.transformation}
                </span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-border">
                <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center">
                  <span className="text-sm font-semibold text-foreground/60">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-medium text-foreground text-sm">{testimonial.name}</p>
                  <p className="text-xs text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-14 text-center">
          <p className="text-muted-foreground mb-2 text-sm">
            {content.testimonials_cta_text}
          </p>
          <a href="#contact" className="text-foreground text-sm font-normal hover:underline">
            Start Your Transformation →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
